import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-primary-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Image */}
          <div className="flex-shrink-0 w-48 md:w-56">
            <img
              src={appData.image}
              alt="吃瓜在线移动端观看"
              title="吃瓜在线手机观看"
              className="w-full h-auto rounded-2xl"
            />
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-primary-600 font-medium mb-4">
              {appData.subtitle}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appData.desc}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appData.features.map((feat, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-background-100 text-foreground-700 text-xs md:text-sm font-medium border border-background-200"
                >
                  <i className={`text-xs ${idx === 0 ? 'ri-download-line' : idx === 1 ? 'ri-eye-line' : idx === 2 ? 'ri-speed-mini-line' : 'ri-aspect-ratio-line'}`}></i>
                  {feat}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}